// React
import React, { useState, useEffect, useRef } from "react";

// Ionic
import {
  IonModal,
  IonButton,
  IonCheckbox,
  IonLabel,
  IonItem,
  IonInput,
  IonIcon,
  IonRow,
  IonCol,
} from "@ionic/react";

import { navigateCircleOutline, closeOutline } from "ionicons/icons";
import UserService from "../../Context/user.service";
import userService from "../../Context/user.service";

function RouteSearch(props) {
  // Modal dunctions
  const [isLoaded, setIsLoaded] = useState(true);
  const [activeFilter, setActiveFilter] = useState(props.activeFilter);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hascustomRoute, setHascustomRoute] = useState(false);

  useEffect(() => {
    setActiveFilter(props.activeFilter);
    setIsLoaded(true);

    UserService.getLastRoute(props.pid,props.token).then(
        (response) => {


          if(response.data.routes[0].items.length ==0) {
            setIsModalOpen(true);
          } else {
            setIsModalOpen(true);
            setHascustomRoute(true);
            setTimeout(function (){
              document.querySelector("[name='from']").value = response.data.routes[0].items[0];
              document.querySelector("[name='to']").value = response.data.routes[0].items[1];
              //document.querySelector("#sendSearch").click();
            },350)

          }

        },
        (error) => {
          console.log(error);
        }
    );


  }, []);

  function openModal() {
    setIsModalOpen(true);
  }
  function closeModal() {
    setIsModalOpen(false);
  }

  function onWillDismiss() {
    setIsModalOpen(false);
  }

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert("Standortdaten werden von ihrem Browser nicht unterstützt.");
    }
  }

  function showPosition(position) {
    document.getElementById("routeFrom").value =
      position.coords.latitude + "," + position.coords.longitude;
  }

  function fireRoute() {

    var from  = document.querySelector("#routeFrom input").value;
    var to = document.querySelector("#routeTo input").value

    props.getCustomRoute(
        from, to
    );

    if(document.getElementById("saveRoute").getAttribute("aria-checked")=="true") {

      var list = [];
      list[0] = {
        "name" : "Standardroute",
          "items" : [JSON.stringify(from),JSON.stringify(to)]
      }
      var route=[];
      route[0] =  {
        "pid":props.pid,
        "routes" : list
      };

      if(hascustomRoute=== true) {
        if(window.confirm("Soll die zuvor gespeicherte Route überschrieben werden?")) {
          userService.setLastRoute(props.pid,props.token,route);
        }
      } else {
        userService.setLastRoute(props.pid,props.token,route);
      }
      //setLastRoute
    }
  }

  return isLoaded ? (
    <div>
      <>
      <IonCol className="route__open__wrapper" size="12" size-md="6" size-lg="8">
              <IonButton
                expand="block"
                className="route__open__button"
                shape="round"
                color="secondary"
                onClick={() => openModal()}
              >
                Neue Route planen
              </IonButton>
      </IonCol>
        
        <IonModal
          isOpen={isModalOpen}
          trigger="open-modal"
          id="routemodal"
          onWillDismiss={() => onWillDismiss()}
        >
          <IonRow class="ion-margin">
            <IonCol>
              <h4>Routenplanung</h4>
            </IonCol>
            <IonCol > 
              {" "}
              <IonButton  onClick={() => closeModal()} fill="clear" className="ion-float-end">
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonCol>

            <IonCol size="12" className="wrapper__route__input">
              <p>Von wo wollen Sie starten?</p>
              <IonButton
                shape="round"
                color="danger"
                size="small"
                onClick={() => getLocation()}
              >
                {" "}
                <IonIcon icon={navigateCircleOutline} slot="start" />
                Aktueller Standort
              </IonButton>{" "}
              <IonItem>
                <IonInput
                  name={"from"}
                  id={"routeFrom"}
                  label="Start der Route"
                  placeholder="Start eingeben"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      fireRoute();
                      closeModal();
                    }
                  }}
                ></IonInput>
              </IonItem>
              <IonItem>
                <IonInput
                  name={"to"}
                  id={"routeTo"}
                  label="Ziel der Route"
                  placeholder="Wo soll es hingehen?"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      fireRoute();
                      closeModal();
                    }
                  }}
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel>Route speichern?</IonLabel>
                <IonCheckbox id="saveRoute" value="1" />
              </IonItem>


              <div className="wrapper__route__button">
                <IonButton
                  shape="round"
                  id="sendSearch"
                  onClick={() => {
                    fireRoute();
                    closeModal();
                  }}
                >
                  Route planen
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonModal>
      </>
    </div>
  ) : (
    <></>
  );
}

export default RouteSearch;
